<template>
  <b-modal
    :id="modalId"
    :title="modalTitle"
    size="lg"
    ok-title="Guardar"
    cancel-title="Cancelar"
    @ok="handleSubmit"
    @hidden="resetForm"
  >
    <b-form @submit.prevent="handleSubmit">
      <b-row>
        <b-col md="6">
          <b-form-group label="Primer Nombre *">
            <b-form-input
              v-model="form.primerNombre"
              placeholder="Ej: Juan"
              required
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Segundo Nombre">
            <b-form-input
              v-model="form.segundoNombre"
              placeholder="Ej: Carlos"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col md="6">
          <b-form-group label="Tercer Nombre">
            <b-form-input
              v-model="form.tercerNombre"
              placeholder="Ej: José"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Primer Apellido *">
            <b-form-input
              v-model="form.primerApellido"
              placeholder="Ej: Pérez"
              required
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col md="6">
          <b-form-group label="Segundo Apellido">
            <b-form-input
              v-model="form.segundoApellido"
              placeholder="Ej: García"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Email">
            <b-form-input
              v-model="form.email"
              type="email"
              placeholder="ejemplo@correo.com"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col md="6">
          <b-form-group label="Teléfono">
            <b-form-input
              v-model="form.telefono"
              placeholder="55551234"
              maxlength="20"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Estado">
            <b-form-select
              v-model="form.estado"
              :options="statusOptions"
              required
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-alert variant="info" show class="mt-2">
        <div class="alert-body">
          <feather-icon icon="InfoIcon" class="mr-50" />
          <span>Los campos marcados con * son obligatorios</span>
        </div>
      </b-alert>
    </b-form>
  </b-modal>
</template>

<script>
import { 
  BModal, 
  BForm, 
  BFormGroup, 
  BFormInput, 
  BFormSelect, 
  BRow, 
  BCol,
  BAlert 
} from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    BAlert,
  },
  props: {
    personData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalId: 'person-modal',
      form: {
        personaId: null,
        primerNombre: '',
        segundoNombre: '',
        tercerNombre: '',
        primerApellido: '',
        segundoApellido: '',
        email: '',
        telefono: '',
        estado: true,
      },
      statusOptions: [
        { text: 'Activo', value: true },
        { text: 'Inactivo', value: false }
      ],
    }
  },
  computed: {
    modalTitle() {
      return this.form.personaId ? 'Editar Persona' : 'Nueva Persona'
    },
    nombresCompletos() {
      const nombres = [
        this.form.primerNombre,
        this.form.segundoNombre,
        this.form.tercerNombre
      ].filter(n => n && n.trim()).join(' ')
      return nombres
    },
    apellidosCompletos() {
      const apellidos = [
        this.form.primerApellido,
        this.form.segundoApellido
      ].filter(a => a && a.trim()).join(' ')
      return apellidos
    },
  },
  watch: {
    personData(newData) {
      if (newData) {
        // Si estamos editando, separar los nombres y apellidos
        const nombres = newData.nombres.trim().split(' ')
        const apellidos = newData.apellidos.trim().split(' ')
        
        this.form = {
          personaId: newData.personaId,
          primerNombre: nombres[0] || '',
          segundoNombre: nombres[1] || '',
          tercerNombre: nombres[2] || '',
          primerApellido: apellidos[0] || '',
          segundoApellido: apellidos[1] || '',
          email: newData.email || '',
          telefono: newData.telefono || '',
          estado: newData.estado,
        }
      } else {
        this.resetForm()
      }
    },
  },
  methods: {
    handleSubmit() {
      // Validar campos requeridos
      if (!this.form.primerNombre.trim() || !this.form.primerApellido.trim()) {
        this.$toast({
          component: this.$options.components.ToastificationContent || null,
          props: {
            title: 'Campos Requeridos',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
            text: 'Debe completar el primer nombre y primer apellido',
          },
        })
        return
      }

      // Preparar datos para enviar
      const dataToSend = {
        nombres: this.nombresCompletos,
        apellidos: this.apellidosCompletos,
        email: this.form.email || null,
        telefono: this.form.telefono || null,
        estado: this.form.estado,
      }

      if (this.form.personaId) {
        dataToSend.personaId = this.form.personaId
      }

      this.$emit('submit', dataToSend)
      this.$bvModal.hide(this.modalId)
    },
    resetForm() {
      this.form = {
        personaId: null,
        primerNombre: '',
        segundoNombre: '',
        tercerNombre: '',
        primerApellido: '',
        segundoApellido: '',
        email: '',
        telefono: '',
        estado: true,
      }
    },
  },
}
</script>

<style scoped>
.alert-body {
  display: flex;
  align-items: center;
}
</style>

